import { ifElse } from 'aa_common/front-end/helpers'
import { PresenterDepreciationResultsAdjustAdjustmentResponse } from 'common/open-api'
import { useMemo } from 'react'

import { prependMissingHistory } from '../helpers/accelerated-depr-history'

export const usePrepareAdjustDepreciation = (
  adjustHistory?: PresenterDepreciationResultsAdjustAdjustmentResponse,
  isRegisterEvent?: boolean
) => {
  return useMemo(() => {
    const acceleratedBefore = adjustHistory?.before?.adjustment
    const acceleratedAfter = adjustHistory?.after?.adjustment
    const tableData = [] as {
      id?: number
      year?: number
      month?: number
      beforeChange?: number
      afterChange?: number
    }[]

    if (acceleratedBefore?.length && acceleratedAfter?.length) {
      const newAcceleratedBefore = prependMissingHistory(acceleratedBefore, acceleratedAfter)
      const newAcceleratedAfter = prependMissingHistory(acceleratedAfter, acceleratedBefore)
      const numberRow = ifElse(
        isRegisterEvent,
        newAcceleratedAfter.length,
        Math.max(newAcceleratedBefore.length, newAcceleratedAfter.length)
      )
      for (let i = 0; i < numberRow; i++) {
        const before = newAcceleratedBefore[i]
        const after = newAcceleratedAfter[i]

        tableData.push({
          id: before?.term_month?.id ?? after?.term_month?.id,
          year: before?.term_month?.term?.year ?? after?.term_month?.term?.year,
          month: before?.term_month?.month ?? after?.term_month?.month,
          beforeChange: before?.depreciation_amount ?? 0,
          afterChange: after?.depreciation_amount ?? 0,
        })
      }
    }

    return tableData
  }, [adjustHistory, isRegisterEvent])
}
